<template>
  <el-button :type="type" :size="size" :disabled="disabled" @click="click">{{
    buttonText
  }}</el-button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      defaultValue: "按钮文本",
    },
    type: {
      defaultValue: "primary",
    },
    size: {
      defaultValue: "large",
    },
    count: {
      require: true,
      defaultValue: 60,
    },
    method: { type: Function, require: true },
  },
  name: "Footer",
  data() {
    return {
      disabled: false,
      timer: null,
      num: 0,
      buttonText: "",
    };
  },

  created() {
    this.buttonText = this.text;
    this.num = this.count;
  },

  methods: {
    click() {
      this.method();
    },
    start() {
      if (this.num == this.count) {
        this.timer = setInterval(() => {
          if (this.num > 0) {
            this.num -= 1;
            this.buttonText = this.num + "秒";
            this.disabled = true;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.num = this.count;
            this.buttonText = this.text;
            this.disabled = false;
          }
        }, 1000);
      }
    },

    stop() {
      clearInterval(this.timer);
      this.timer = null;
      this.num = this.count;
      this.buttonText = this.text;
      this.disabled = false;
    },
  },
};
</script>

<style scoped></style>
